import { Suspense } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { Loader } from '@/shared/ui/loader'
import { DonationTab } from '@pages/donor-detail/ui/DonationTab'

function DonationRoute() {
  const { visitId } = Route.useParams()
  return (
    <Suspense fallback={<Loader />}>
      <DonationTab visitId={visitId} />
    </Suspense>
  )
}

export const Route = createFileRoute(
  '/_protected/labarotaroyResearch/$visitId/donation',
)({
  component: DonationRoute,
})
